import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormDirtyState {
  isDirty: boolean;
}

const initialState: FormDirtyState = {
  isDirty: false,
};

const formDirtySlice = createSlice({
  name: 'formDirty',
  initialState,
  reducers: {
    setDirty: (state) => {
      state.isDirty = true;
      console.log("dirtyyyy",state.isDirty)
    },
    setPristine: (state) => {
      state.isDirty = false;
    },
    setDirtyValue: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload;
      
    },
    resetAllDirty: (state) => {
      state.isDirty = false;
    },
  },
});

export const { setDirty, setPristine, setDirtyValue, resetAllDirty } = formDirtySlice.actions;
export default formDirtySlice.reducer; 